/**
 * Generated from ch10_p02.fla
 */
export function ch10_p02(this: Ich10_p02) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_holly.call(holly[0] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_holly);
		holly[0].x = 835;
		holly[0].y = 768;
		holly[0].width = 390.00;
		holly[0].height = 658.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p03_holly.call(holly[1] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p03_holly);
		holly[1].x = 839.5;
		holly[1].y = 768;
		holly[1].width = 348.00;
		holly[1].height = 658.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const lights = this.lights;
	if (!lights[0] && lights.elementFactory) {
		lights[0] = lights.elementFactory(0,undefined);
	}
	if (lights[0]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer57.call(lights[0] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer57);
		lights[0].x = 668;
		lights[0].y = 405.5;
		lights[0].width = 1336.00;
		lights[0].height = 725.00;
		lights[0].alpha = 1;
		if (lights[0].onLayout) lights[0].onLayout();
	}
	if (!lights[1] && lights.elementFactory) {
		lights[1] = lights.elementFactory(1,undefined);
	}
	if (lights[1]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer135copy.call(lights[1] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer135copy);
		lights[1].x = 763.25;
		lights[1].y = 344;
		lights[1].width = 1526.50;
		lights[1].height = 688.00;
		lights[1].alpha = 1;
		if (lights[1].onLayout) lights[1].onLayout();
	}
	const confetti = this.confetti;
	if (!confetti[0] && confetti.elementFactory) {
		confetti[0] = confetti.elementFactory(0,undefined);
	}
	if (confetti[0]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer59.call(confetti[0] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer59);
		confetti[0].x = 721.5;
		confetti[0].y = 349;
		confetti[0].width = 1443.00;
		confetti[0].height = 698.00;
		confetti[0].alpha = 1;
		if (confetti[0].onLayout) confetti[0].onLayout();
	}
	if (!confetti[1] && confetti.elementFactory) {
		confetti[1] = confetti.elementFactory(1,undefined);
	}
	if (confetti[1]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer60.call(confetti[1] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer60);
		confetti[1].x = 840.75;
		confetti[1].y = 362.25;
		confetti[1].width = 1543.50;
		confetti[1].height = 666.50;
		confetti[1].alpha = 1;
		if (confetti[1].onLayout) confetti[1].onLayout();
	}
	if (!confetti[2] && confetti.elementFactory) {
		confetti[2] = confetti.elementFactory(2,undefined);
	}
	if (confetti[2]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer61.call(confetti[2] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer61);
		confetti[2].x = 898.5;
		confetti[2].y = 359.5;
		confetti[2].width = 1531.00;
		confetti[2].height = 525.00;
		confetti[2].alpha = 1;
		if (confetti[2].onLayout) confetti[2].onLayout();
	}
	if (!confetti[3] && confetti.elementFactory) {
		confetti[3] = confetti.elementFactory(3,undefined);
	}
	if (confetti[3]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer77copy.call(confetti[3] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer77copy);
		confetti[3].x = 822;
		confetti[3].y = 367;
		confetti[3].width = 1644.00;
		confetti[3].height = 648.00;
		confetti[3].alpha = 1;
		if (confetti[3].onLayout) confetti[3].onLayout();
	}
	if (!confetti[4] && confetti.elementFactory) {
		confetti[4] = confetti.elementFactory(4,undefined);
	}
	if (confetti[4]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer62.call(confetti[4] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer62);
		confetti[4].x = 898.25;
		confetti[4].y = 358.5;
		confetti[4].width = 1309.50;
		confetti[4].height = 717.00;
		confetti[4].alpha = 1;
		if (confetti[4].onLayout) confetti[4].onLayout();
	}
	if (!confetti[5] && confetti.elementFactory) {
		confetti[5] = confetti.elementFactory(5,undefined);
	}
	if (confetti[5]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer78copy.call(confetti[5] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer78copy);
		confetti[5].x = 936.25;
		confetti[5].y = 279.5;
		confetti[5].width = 1350.50;
		confetti[5].height = 555.00;
		confetti[5].alpha = 1;
		if (confetti[5].onLayout) confetti[5].onLayout();
	}
	if (!confetti[6] && confetti.elementFactory) {
		confetti[6] = confetti.elementFactory(6,undefined);
	}
	if (confetti[6]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer63.call(confetti[6] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer63);
		confetti[6].x = 840;
		confetti[6].y = 277.5;
		confetti[6].width = 1565.00;
		confetti[6].height = 494.00;
		confetti[6].alpha = 1;
		if (confetti[6].onLayout) confetti[6].onLayout();
	}
	if (!confetti[7] && confetti.elementFactory) {
		confetti[7] = confetti.elementFactory(7,undefined);
	}
	if (confetti[7]) {
		ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer79copy.call(confetti[7] as Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer79copy);
		confetti[7].x = 867.25;
		confetti[7].y = 330.75;
		confetti[7].width = 1497.50;
		confetti[7].height = 661.50;
		confetti[7].alpha = 1;
		if (confetti[7].onLayout) confetti[7].onLayout();
	}
	const bg = this.bg;
	ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const textureColorDodge = this.textureColorDodge;
	ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightstexture.call(this.textureColorDodge);
	textureColorDodge.x = 756.5;
	textureColorDodge.y = 556.5;
	textureColorDodge.width = 1333.00;
	textureColorDodge.height = 423.00;
	textureColorDodge.alpha = 1.00;
	if (textureColorDodge.onLayout) textureColorDodge.onLayout();
	const frameRight = this.frameRight;
	ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeRRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeLLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_bg(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p02_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_holly(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p02_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p03_holly(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p03_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p03_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightstexture(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightstexture) {
	if (this.setLayoutTexture) this.setLayoutTexture("texture", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer57(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer57) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer57", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer135copy(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer135copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer135copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer59(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer59) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer59", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer60(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer60) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer60", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer61(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer61) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer61", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer77copy(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer77copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer77copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer62(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer62) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer62", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer78copy(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer78copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer78copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer63(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer63) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer63", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer79copy(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer79copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer79copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeRRframe(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeRRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeLLframe(this: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeLLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich10_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich10_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich10_p02Sprite extends Ich10_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich10_p02Text extends Ich10_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich10_p02Polygon extends Array<number> {
}
interface Ich10_p02 {
	readonly holly: Ich10_p02Array<Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_holly|Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p03_holly>;
	readonly lights: Ich10_p02Array<Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer57|Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer135copy>;
	readonly confetti: Ich10_p02Array<Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer59|Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer60|Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer61|Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer77copy|Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer62|Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer78copy|Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer63|Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer79copy>;
	readonly bg: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_bg;
	readonly textureColorDodge: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightstexture;
	readonly frameRight: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeRRframe;
	readonly frameLeft: Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeLLframe;
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_bg extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_holly extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p03_holly extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightstexture extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer57 extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_lightsLayer135copy extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer59 extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiLayer60 extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer61 extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiyellowLayer77copy extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer62 extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfetticyanLayer78copy extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer63 extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetconfettiredLayer79copy extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeRRframe extends Ich10_p02Sprite {
}
interface Ich10_p02_hh_ch010_72dpi_p0203psdAssetchp10_p02_wcframeLLframe extends Ich10_p02Sprite {
}
